// @ts-check

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import adminAuthService from '../services/adminAuthService';

const AdminLoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await adminAuthService.login(email, password);

      // Verify token was stored
      const storedToken = localStorage.getItem('adminToken');
      if (!storedToken) {
        throw new Error('Failed to store authentication token');
      }

      // Use replace instead of navigate to avoid back button issues
      navigate('/dashboard', { replace: true });
    } catch (err) {
      console.error('Login error:', err);
      setError(err.message || 'Invalid email or password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-muted/50">
      <div className="max-w-md w-full px-6">
        <div className="text-center mb-8">
          <h1 className="text-4xl mb-2 font-serif" style={{ fontWeight: 300, letterSpacing: '0.1em' }}>
            KAAY
          </h1>
          <p className="text-sm text-muted-foreground uppercase tracking-widest">Admin Panel</p>
        </div>

        <div className="bg-card p-8 shadow-sm border rounded-lg border-border">
          <h2 className="text-2xl mb-6 text-center font-serif">Sign In</h2>

          {error && (
            <div className="mb-4 p-3 bg-red-50 dark:bg-red-950/50 border rounded-lg border-red-200 dark:border-red-900 text-red-800 dark:text-red-300 text-sm">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label className="block text-sm font-medium text-foreground/80 mb-2">Email Address</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-2 border rounded-lg border-input focus:outline-none focus:border-foreground"
                required
              />
            </div>

            <div className="mb-6">
              <label className="block text-sm font-medium text-foreground/80 mb-2">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-2 border rounded-lg border-input focus:outline-none focus:border-foreground"
                required
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-primary text-primary-foreground py-3 text-sm uppercase tracking-widest hover:bg-primary/90 disabled:bg-muted-foreground/50"
            >
              {loading ? 'Signing In...' : 'Sign In'}
            </button>
          </form>

          <div className="mt-6 text-center">
            <p className="text-sm text-muted-foreground">
              Need an admin account?{' '}
              <a href="/register" className="underline hover:text-foreground">
                Register here
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLoginPage;
